import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  CREATE_VENDOR: `${SLICE_NAME}/create_vendor`,
  UPDATE_VENDOR: `${SLICE_NAME}/update_vendor`,
  DELETE_VENDOR: `${SLICE_NAME}/delete_vendor`,
  RETRIEVE_VENDOR: `${SLICE_NAME}/get_vendor`,
  RETRIEVE_MANY_VENDORS: `${SLICE_NAME}/get_many_vendors`,
} as const;
